export default __webpack_public_path__ + "static/media/sunlight_view_setting.9bc8cd18.svg";